import { useEffect, useState } from "react";
import {
  Link,
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation
} from "react-router-dom";
import { initKFL } from "@kamstrup/kfl";
import dayjs from "dayjs";
import timeZone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import "./App.css";
import { Box, Typography } from "@kamstrup/kfl";
import { ResetPasswordPageWithProvider } from "./pages/resetPassword/ResetPasswordPage";
import { NewUserPageWithProvider } from "./pages/newUser/NewUserPage";
import { InviteExistingUserPageWithProvider } from "./pages/inviteExistingUser/InviteExistingUserPage";
import { TranslationsProvider } from "@kamstrup/kamstrup-intl";
import { supportedLocales } from "./hooks/useTranslationHook/types";
import { useCustomer } from "./hooks/useCustomer";
import { getLan } from "./utils/languageManager";
import { useTranslation } from "./hooks/useTranslationHook/useTranslation";
import { InviteNewUserPageWithProvider } from "./pages/inviteNewUser/InviteNewUserPage";

initKFL();
dayjs.extend(utc);
dayjs.extend(timeZone);

const ENV = process.env.REACT_APP_ENV;

const isProd = ENV === "production";

const MyKamstrupToolbar = () => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        padding: "8px 16px",
        backgroundColor: "#f7f7f7",
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)"
      }}
    >
      <Box
        sx={{
          backgroundColor: "#FF0000",
          color: "#FFFFFF",
          padding: "4px 12px",
          borderRadius: "4px",
          fontWeight: "bold",
          fontSize: "18px"
        }}
      >
        Login User Registration Menu
      </Box>
    </Box>
  );
};

const HomePage = () => {
  const [openStories, setOpenStories] = useState<string[]>([]);
  const toggleStory = (story: string) => {
    setOpenStories((prev) =>
      prev.includes(story) ? prev.filter((s) => s !== story) : [...prev, story]
    );
  };

  return (
    <div>
      <MyKamstrupToolbar />
      <div
        style={{
          padding: "16px",
          backgroundColor: "#f7f7f7",
          height: "calc(100vh - 64px)",
          overflowY: "auto"
        }}
      >
        <Typography
          variant="h5"
          sx={{
            marginBottom: "16px",
            color: "#212121"
          }}
        >
          Choose a page to navigate:
        </Typography>
        <nav>
          <ul style={{ listStyleType: "none", padding: 0 }}>
            {/* Story: User creation story */}
            <li>
              <div
                style={{
                  cursor: "pointer",
                  padding: "8px",
                  backgroundColor: "#EFEFEF",
                  marginBottom: "8px",
                  borderRadius: "4px",
                  fontWeight: "bold"
                }}
                onClick={() => toggleStory("userCreation")}
              >
                {openStories.includes("userCreation") ? "▼" : "▶"} User Creation Story
              </div>
              {openStories.includes("userCreation") && (
                <ul style={{ listStyleType: "none", paddingLeft: "16px" }}>
                  <li>
                    <Link
                      to="/user-creation"
                      style={{
                        textDecoration: "none",
                        color: "#007bff"
                      }}
                    >
                      User Creation
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/user-creation?invitationAccepted=true"
                      style={{
                        textDecoration: "none",
                        color: "#007bff"
                      }}
                    >
                      User Invite (Accepted)
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/* Story: Change Password */}
            <li>
              <div
                style={{
                  cursor: "pointer",
                  padding: "8px",
                  backgroundColor: "#EFEFEF",
                  marginBottom: "8px",
                  borderRadius: "4px",
                  fontWeight: "bold"
                }}
                onClick={() => toggleStory("changePassword")}
              >
                {openStories.includes("changePassword") ? "▼" : "▶"} Change Password Story
              </div>
              {openStories.includes("changePassword") && (
                <ul style={{ listStyleType: "none", paddingLeft: "16px" }}>
                  <li>
                    <Link
                      to="/change-password"
                      style={{
                        textDecoration: "none",
                        color: "#007bff"
                      }}
                    >
                      Change Password
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/* Story: Forgot Password */}
            <li>
              <div
                style={{
                  cursor: "pointer",
                  padding: "8px",
                  backgroundColor: "#EFEFEF",
                  marginBottom: "8px",
                  borderRadius: "4px",
                  fontWeight: "bold"
                }}
                onClick={() => toggleStory("resetPassword")}
              >
                {openStories.includes("resetPassword") ? "▼" : "▶"} Forgot Password Story
              </div>
              {openStories.includes("resetPassword") && (
                <ul style={{ listStyleType: "none", paddingLeft: "16px" }}>
                  <li>
                    <Link
                      to="/reset-password"
                      style={{
                        textDecoration: "none",
                        color: "#007bff"
                      }}
                    >
                      Forgot Password
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/* New Story: Move Organization */}
            <li>
              <div
                style={{
                  cursor: "pointer",
                  padding: "8px",
                  backgroundColor: "#EFEFEF",
                  marginBottom: "8px",
                  borderRadius: "4px",
                  fontWeight: "bold"
                }}
                onClick={() => toggleStory("inviteExistingUser")}
              >
                {openStories.includes("inviteExistingUser") ? "▼" : "▶"} Move Organization Story
              </div>
              {openStories.includes("inviteExistingUser") && (
                <ul style={{ listStyleType: "none", paddingLeft: "16px" }}>
                  <li>
                    <Link
                      to="/move-organization/HnHVeCvywEapeDnf8ixj4g%3D%3D.ziv22cu9WEzVkt2QRIMf8VGkDKYy2S%2FZV8mAtsUAizU%3D"
                      style={{
                        textDecoration: "none",
                        color: "#007bff"
                      }}
                    >
                      Move to ExampleOrg
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/* New Story: Move Organization */}
            <li>
              <div
                style={{
                  cursor: "pointer",
                  padding: "8px",
                  backgroundColor: "#EFEFEF",
                  marginBottom: "8px",
                  borderRadius: "4px",
                  fontWeight: "bold"
                }}
                onClick={() => toggleStory("inviteExistingUserExternal")}
              >
                {openStories.includes("inviteExistingUserExternal") ? "▼" : "▶"} Invite existing
                User Story External
              </div>
              {openStories.includes("inviteExistingUserExternal") && (
                <ul style={{ listStyleType: "none", paddingLeft: "16px" }}>
                  <li>
                    <Link
                      to="/user-invitation/HnHVeCvywEapeDnf8ixj4g%3D%3D.ziv22cu9WEzVkt2QRIMf8VGkDKYy2S%2FZV8mAtsUAizU%3D"
                      style={{
                        textDecoration: "none",
                        color: "#007bff"
                      }}
                    >
                      Invite existing user (external)
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/* New Story: User invitation */}
            <li>
              <div
                style={{
                  cursor: "pointer",
                  padding: "8px",
                  backgroundColor: "#EFEFEF",
                  marginBottom: "8px",
                  borderRadius: "4px",
                  fontWeight: "bold"
                }}
                onClick={() => toggleStory("inviteNewUser")}
              >
                {openStories.includes("inviteNewUser") ? "▼" : "▶"} Invite User Story
              </div>
              {openStories.includes("inviteNewUser") && (
                <ul style={{ listStyleType: "none", paddingLeft: "16px" }}>
                  <li>
                    <Link
                      to="/new-user-invitation/HnHVeCvywEapeDnf8ixj4g%3D%3D.ziv22cu9WEzVkt2QRIMf8VGkDKYy2S%2FZV8mAtsUAizU%3D"
                      style={{
                        textDecoration: "none",
                        color: "#007bff"
                      }}
                    >
                      Invite new user
                    </Link>
                  </li>
                </ul>
              )}
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

const routeTitleKey: Record<string, string> = {
  "/user-creation": "new_user",
  "/user-invitation": "accept_invitation",
  "/move-organization": "move_organization",
  "/change-password": "change_password",
  "/reset-password": "forgot_password",
  "/new-user-invitation": "accept_invitation"
};

const resolveTitleKey = (path: string): string | undefined => {
  if (path.startsWith("/new-user-invitation")) return "accept_invitation";
  if (path.startsWith("/user-invitation")) return "accept_invitation";
  if (path.startsWith("/move-organization")) return "move_organization";
  return routeTitleKey[path];
};

export const TitleManager = () => {
  const { translateString, locale } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    const key = resolveTitleKey(location.pathname);
    const translated = key ? translateString(key as any) : "";
    document.title = translated ? `Kamstrup: ${translated}` : "Kamstrup";
  }, [translateString, locale, location.pathname]);

  return null;
};

const App = () => {
  const currentLocale = getLan();
  const translationsMessage = require(`../src/i18n/${currentLocale}/translations.json`);
  const ianaTimeZone = useCustomer();

  useEffect(() => {
    if (ianaTimeZone) {
      dayjs.tz.setDefault(ianaTimeZone);
    }
  }, [ianaTimeZone]);

  return (
    <TranslationsProvider
      messages={translationsMessage}
      supportedLocales={supportedLocales}
      timeZone={ianaTimeZone}
    >
      <Router>
        <TitleManager />
        <Routes>
          <Route path="/" element={isProd ? <Navigate to="/user-creation" /> : <HomePage />} />
          <Route path="/user-creation" element={<NewUserPageWithProvider />} />
          <Route
            path="/new-user-invitation/:workflowId"
            element={<InviteNewUserPageWithProvider />}
          />
          <Route
            path="/user-invitation/:workflowId"
            element={<InviteExistingUserPageWithProvider variant="external" />}
          />
          <Route
            path="/move-organization/:workflowId"
            element={<InviteExistingUserPageWithProvider variant="primary" />}
          />
          <Route
            path="/change-password"
            element={<ResetPasswordPageWithProvider mode="change" />}
          />
          <Route path="/reset-password" element={<ResetPasswordPageWithProvider mode="reset" />} />
        </Routes>
      </Router>
    </TranslationsProvider>
  );
};

export default App;
